import { render, staticRenderFns } from "./DashboardMajorPayrollMovement.vue?vue&type=template&id=1df878ba"
import script from "./DashboardMajorPayrollMovement.vue?vue&type=script&lang=js"
export * from "./DashboardMajorPayrollMovement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports